import vue from 'vue';

export default function buildFileStore(store)
{
    store.actions.getSequenceFileList = async (context, params) => await vue.prototype.$myHttp.post('/api/files/GetSequenceFileList', params);
    return store;
}
